import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import { ToastProvider } from '../common/ToastProvider'
import ErrorBoundary from '../common/ErrorBoundary'

export default function Layout() {
  const [showTickerExtras, setShowTickerExtras] = useState(false)
  const [competition, setCompetition] = useState(null)
  const [message, setMessage] = useState('Live Results')

  return (
    <ToastProvider>
      <div className="max-w-[1200px] mx-auto  min-h-screen bg-gray-50">
        <div className="px-4 py-2">
          <Header 
            showTickerExtras={showTickerExtras}
            competition={competition}
            message={message}
          />
          <main className="mt-6">
            <ErrorBoundary>
              <Outlet context={{
                setShowTickerExtras,
                setCompetition,
                setMessage
              }} />
            </ErrorBoundary>
          </main>
        </div>
      </div>
    </ToastProvider>
  )
}
